import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter,MAT_DATE_LOCALE,MAT_DATE_FORMATS } from '@angular/material';
import { Observable } from 'rxjs/Rx';
import { startWith, map } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import {  Router } from '@angular/router';
import { DatePipe } from "@angular/common";
import Swal from "sweetalert2";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates, MessagesSimuladorAgregarDetalle } from '../../models/messages';
import { SimuladorService } from '../../services/operaciones/simulador/simulador.service';
import { CobranzasService } from '../../services/cobranzas/cobranzas.service';
import { LoginService } from 'app/services/login/login.service';
import { AdquirenteCuotaComponent } from './adquirente-cuota/adquirente-cuota.component';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-pagos',
  templateUrl: './pagos.component.html',
  styleUrls: ['./pagos.component.scss'],
  providers: [MessagesTitles,MessagesGeneral,MessagesDates,
    DatePipe,AdquirenteCuotaComponent,MessagesSimuladorAgregarDetalle,
  
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]

})
export class PagosComponent implements OnInit {

  flagProformaDetalle : boolean = false;
  idProforma : number = 0;

  proformas : any = [];
  ruc = new FormControl();
  rucAdq = new FormControl();

  estados ="R";
  idProv ="" ;
  idAdq ="";


  // Entradas de Busqueda
  RUC_PROV : string;
  RUC_ADQ : string;
  TipoMoneda : string ="S";

  filteredProveeedor: Observable<any[]>;
  proveedoresArr;

  filteredAdquirentes: Observable<any[]>;
  adquirentessArr;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  // usuarios:any[]=[];
  pageSizeOptions = [15,20,30,50,100,200];
  loading:boolean;
  displayedColumns: string[] = 
            ['checked','idComprobante','Fecha_de_Pago','RazonSocialAdquirente','RazonSocialProveedor','Moneda','Importe','Estado','Tipo_Comprobante','Tipo_Emision','Serie','Numero'];
  dataSource :any; 
  constructor(private loginService:LoginService, private simuladorService:SimuladorService,private cobranzasService:CobranzasService,private datePipe :DatePipe , private router:Router,private cuota:AdquirenteCuotaComponent) { }

  ngOnInit() {

    this.ObtenerProveedoresCombo();
    this.ObtenerAdquirentesCombo();
  }

  MetCerrarProformaDetalle(){
    this.flagProformaDetalle = false;
  }
  exportarAExcel(){
    this.cuota.ExportTOExcel();
  }
  ListadoPagoFiltros(){
    this.loading = true;
    if (this.ruc.value == '') this.idProv = '';
    if (this.rucAdq.value == '') this.idAdq = '';
    this.cobranzasService.FiltroListadoPagos(this.TipoMoneda,this.idProv,this.idAdq).subscribe(
        res => {
          this.proformas = res;
          this.dataSource = new MatTableDataSource( this.proformas);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.loading = false;
        } , err =>{
            Swal.fire({
              title: "¡Algo salió mal!",
              text:  err.error['error'],
              type: "warning",
              allowOutsideClick: true,
              heightAuto: false
            });        
          this.loading = false;
        }
    )
  }


  obtenerRucRazSocialAdq(termino :string = ''){
    
    if (termino != null && termino != ''){          
      let termino1 = termino.toLowerCase();                   
  
      for( let p of this.adquirentessArr){
  
          let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1)  >= 0){
            this.idAdq = p.Num_Doc_Identificacion;
          }
      }
    }
  }
  

  obtenerRucRazSocialProv(termino :string = ''){
    if (termino != null && termino != ''){
      
      let termino1 = termino.toLowerCase();                   
  
      for( let p of this.proveedoresArr){
  
          let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1)  >= 0){
            this.idProv = p.Num_Doc_Identificacion;
          }
   
      }

    }

  }
  

  ObtenerProveedoresCombo() {
    this.proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));

      this.filteredProveeedor = this.ruc.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterProv(state) : this.proveedoresArr.slice()
        )
      );  
  }

  private _filterProv(value: string): any[] {
    const filterValue = value.toString().toLowerCase();

    return this.proveedoresArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }

  ObtenerAdquirentesCombo() {
    
      this.adquirentessArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));
      this.filteredAdquirentes = this.rucAdq.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterAdq(state) : this.adquirentessArr.slice()
        )
      );
   
  }

  private _filterAdq(value: string): any[] {
    const filterValue = value.toString().toLowerCase();

    return this.adquirentessArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }

  obtenerRucProv(termino :string){
    this.idProv = termino;
  }

  
  obtenerRucAdq(termino :string){
    this.idAdq = termino;
  }

  enviarIdProforma(idProforma:any){
    this.idProforma = idProforma;
    this.flagProformaDetalle = true;
  }


  clickGuard(){
    this.loginService.clickGuard = true;
 }


}
